import { booleanAttribute, Component, input } from '@angular/core';

import { environment } from '@env/environment';

import { Button } from '../button/button';

export interface PictureCredit {
  name: string;
  work: string;
}

@Component({
  selector: 'app-cta-panel',
  imports: [Button],
  templateUrl: './cta-panel.html',
  styleUrl: './cta-panel.scss',
})
export class CtaPanel {
  readonly title = input('The future belongs to those who direct, not those who gamble.');
  readonly ctaButtonText = input('Start now');
  readonly ctaButtonLink = input(`${environment.appUrl}/auth/register`);
  readonly showPictureCredits = input(true, { transform: booleanAttribute });
  readonly pictureCredits = input<PictureCredit[]>([
    { name: 'Vinod Padmanabhan Vijay Kumar', work: 'dragon and carpenter' },
    { name: 'Michael Jones', work: 'old man with fireplace' },
    { name: 'Brandon Vietti', work: 'robot with woman' },
  ]);
}
